
import { Control, Controller, FieldPath, FieldValues, PathValue } from "react-hook-form";
import TextInputList from "../common/TextInputList";

interface TextInputListControllerProps<T extends FieldValues> {
	name: FieldPath<T>;
	control: Control<T>;
	label?: string;
}

const TextInputListController = <T extends FieldValues>({
	name,
	control,
	label,
}: TextInputListControllerProps<T>) => {
	return (
		<Controller
			name={name}
			control={control}
			defaultValue={[] as PathValue<T, FieldPath<T>>}
			render={({ field }) => (
				<TextInputList
					value={field.value}
					onChange={field.onChange}
					label={label}
				/>
			)}
		/>
	);
};

export { TextInputListController };
